// JS file for Search

const linkCollapse = $('.j-link-collapse');

linkCollapse.on('show.bs.collapse', (e) => {
  let $this = $(e.currentTarget);
  $this.prev().children('i').removeClass('fa-plus');
  $this.prev().children('i').addClass('fa-minus');
});

linkCollapse.on('hide.bs.collapse', (e) => {
  let $this = $(e.currentTarget);

  $this.prev().children('i').removeClass('fa-minus');
  $this.prev().children('i').addClass('fa-plus');
});
